import React, { useState } from "react";
import "./pos_index.css";

const PosIndex = () => {
  const [sku, setSku] = useState("");
  const [items, setItems] = useState([]);
  const [discount, setDiscount] = useState(0);
  const [showReceipt, setShowReceipt] = useState(false);

  const userId = 1; // Replace with auth
  const currentDate = new Date().toLocaleString();

  const addItem = async () => {
    if (!sku.trim()) return alert("SKU required");
    if (items.find((i) => i.SKU === sku)) return alert("Already added");

    try {
      const res = await fetch(`../ord/api/getSkuDetails.php?sku=${sku}`);
      const data = await res.json();
      const product = data[0];
      if (data.message === "Sold") return alert("Sold");
      if (product.Quantity === "0") return alert("Out of stock");

      setItems([...items, product]);
      setSku("");
    } catch (err) {
      console.error(err);
      alert("Failed to fetch SKU");
    }
  };

  const removeItem = (index) => setItems(items.filter((_, i) => i !== index));

  const total = items.reduce(
    (sum, item) => sum + parseFloat(item.Price || 0),
    0,
  );
  const finalTotal = Math.max(total - discount, 0);

  const confirmPurchase = () => {
    if (!items.length) return alert("No items added");
    setShowReceipt(true);
  };

  return (
    <div className="modern-pos-container">
      <h2 className="pos-header">💳 Modern POS</h2>

      <div className="input-section">
        <input
          className="sku-input"
          placeholder="Enter SKU"
          value={sku}
          onChange={(e) => setSku(e.target.value)}
          onKeyPress={(e) => e.key === "Enter" && addItem()}
        />
        <button className="btn add-btn" onClick={addItem}>
          Add
        </button>
      </div>

      {items.length > 0 && (
        <div className="table-section">
          <table className="modern-table">
            <thead>
              <tr>
                {["#", "Title", "Image", "SKU", "Price", "Qty", "Action"].map(
                  (h) => (
                    <th key={h}>{h}</th>
                  ),
                )}
              </tr>
            </thead>
            <tbody>
              {items.map((item, idx) => (
                <tr key={idx}>
                  <td>{idx + 1}</td>
                  <td>{item.Title}</td>
                  <td>
                    <img
                      src={item.Image_1}
                      alt={item.Title}
                      className="item-img"
                    />
                  </td>
                  <td>{item.SKU}</td>
                  <td>{item.Price}</td>
                  <td>{item.Quantity}</td>
                  <td>
                    <button
                      className="btn remove-btn"
                      onClick={() => removeItem(idx)}
                    >
                      ✕
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="totals-container">
            <div>
              <span>Total: {total.toFixed(2)} Rs</span>
              <input
                type="number"
                className="discount-input"
                placeholder="Discount"
                value={discount}
                onChange={(e) => setDiscount(Number(e.target.value))}
              />
            </div>
            <div>
              <span>Final: {finalTotal.toFixed(2)} Rs</span>
              <button className="btn checkout-btn" onClick={confirmPurchase}>
                Checkout
              </button>
            </div>
          </div>
        </div>
      )}

      {showReceipt && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3 className="receipt-title">Receipt</h3>
            <div className="receipt-header">
              <div>User: {userId}</div>
              <div>Date: {currentDate}</div>
            </div>
            <table className="modern-table receipt-table">
              <thead>
                <tr>
                  {["#", "Title", "SKU", "Qty", "Price"].map((h) => (
                    <th key={h}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {items.map((item, idx) => (
                  <tr key={idx}>
                    <td>{idx + 1}</td>
                    <td>{item.Title}</td>
                    <td>{item.SKU}</td>
                    <td>{item.Quantity}</td>
                    <td>{item.Price}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="receipt-totals">
              <span>Total: {total.toFixed(2)} Rs</span>
              <span>Discount: {discount.toFixed(2)} Rs</span>
              <span>Final: {finalTotal.toFixed(2)} Rs</span>
            </div>
            <div className="modal-buttons">
              <button className="btn" onClick={() => setShowReceipt(false)}>
                Close
              </button>
              <button
                className="btn checkout-btn"
                onClick={() => {
                  alert("Purchase confirmed!");
                  setShowReceipt(false);
                  setItems([]);
                  setDiscount(0);
                }}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PosIndex;
